/**
 * Indonesia States/Provinces (Regions) for Wallex beneficiary creation
 * Source: https://api-sg.wallex.plus/beneficiaries/v1/states
 */

export interface IndonesiaState {
  countryId: string;
  stateId: string;
  value: string;
}

export const INDONESIA_STATES: IndonesiaState[] = [
  { countryId: "ID", stateId: "ID-11", value: "Nanggroe Aceh Darussalam" },
  { countryId: "ID", stateId: "ID-12", value: "Sumatera Utara" },
  { countryId: "ID", stateId: "ID-13", value: "Sumatera Barat" },
  { countryId: "ID", stateId: "ID-14", value: "Riau" },
  { countryId: "ID", stateId: "ID-15", value: "Jambi" },
  { countryId: "ID", stateId: "ID-16", value: "Sumatera Selatan" },
  { countryId: "ID", stateId: "ID-17", value: "Bengkulu" },
  { countryId: "ID", stateId: "ID-18", value: "Lampung" },
  { countryId: "ID", stateId: "ID-19", value: "Bangka Belitung" },
  { countryId: "ID", stateId: "ID-21", value: "Kepulauan Riau" },
  { countryId: "ID", stateId: "ID-31", value: "DKI Jakarta" },
  { countryId: "ID", stateId: "ID-32", value: "Jawa Barat" },
  { countryId: "ID", stateId: "ID-33", value: "Jawa Tengah" },
  { countryId: "ID", stateId: "ID-34", value: "D.I. Yogyakarta" },
  { countryId: "ID", stateId: "ID-35", value: "Jawa Timur" },
  { countryId: "ID", stateId: "ID-36", value: "Banten" },
  { countryId: "ID", stateId: "ID-51", value: "Bali" },
  { countryId: "ID", stateId: "ID-52", value: "Nusa Tenggara Barat" },
  { countryId: "ID", stateId: "ID-53", value: "Nusa Tenggara Timur" },
  { countryId: "ID", stateId: "ID-61", value: "Kalimantan Barat" },
  { countryId: "ID", stateId: "ID-62", value: "Kalimantan Tengah" },
  { countryId: "ID", stateId: "ID-63", value: "Kalimantan Selatan" },
  { countryId: "ID", stateId: "ID-64", value: "Kalimantan Timur" },
  { countryId: "ID", stateId: "ID-65", value: "Kalimantan Utara" },
  { countryId: "ID", stateId: "ID-71", value: "Sulawesi Utara" },
  { countryId: "ID", stateId: "ID-72", value: "Sulawesi Tengah" },
  { countryId: "ID", stateId: "ID-73", value: "Sulawesi Selatan" },
  { countryId: "ID", stateId: "ID-74", value: "Sulawesi Tenggara" },
  { countryId: "ID", stateId: "ID-75", value: "Gorontalo" },
  { countryId: "ID", stateId: "ID-76", value: "Sulawesi Barat" },
  { countryId: "ID", stateId: "ID-81", value: "Maluku" },
  { countryId: "ID", stateId: "ID-82", value: "Maluku Utara" },
  { countryId: "ID", stateId: "ID-91", value: "Papua Barat" },
  { countryId: "ID", stateId: "ID-94", value: "Papua" },
];

/**
 * Get state names as dropdown options
 */
export const getIndonesiaStateOptions = (): string[] => {
  return INDONESIA_STATES.map((state) => state.value).sort((a, b) =>
    a.localeCompare(b)
  );
};

/**
 * Get state ID by state name
 */
export const getStateIdByName = (stateName: string): string | undefined => {
  const state = INDONESIA_STATES.find((s) => s.value === stateName);
  return state?.stateId;
};

/**
 * Get state name by state ID
 */
export const getStateNameById = (stateId: string): string | undefined => {
  const state = INDONESIA_STATES.find((s) => s.stateId === stateId);
  return state?.value;
};
